import {connect} from 'react-redux';
import {QCToolsMetadataState} from 'QCTools/QCToolsMetadata/QCToolsMetadataTypes';
import {ContentItemViewMetadataState} from 'ContentItemView/ContentItemViewMetadata/ContentItemViewMetadataTypes';
import {
    IngestDataState,
    InitialEditingIngestConfigState,
    IngestReportState,
} from 'Ingest/IngestData/IngestDataTypes';
import {UserState} from '@pluto/users';
import {Breadcrumbs} from './Breadcrumbs';

export interface ContentItemDataState {
    metaData: {
        filmTitle: string;
    };
}

export type State = {
    qcTools: {
        qcToolsMetadata: QCToolsMetadataState;
    };
    ingest: {
        ingestData: IngestDataState;
        initialValuesForEditingIngestConfig: InitialEditingIngestConfigState;
        ingestReport: IngestReportState;
    };
    contentItem: {
        data: ContentItemDataState;
    };
    contentItemView: {
        contentItemViewMetadata: ContentItemViewMetadataState;
    };
    userDetails: UserState;
};

const mapStateToProps = (state: State) => {
    const {
        qcTools: {qcToolsMetadata},
        ingest: {ingestData, initialValuesForEditingIngestConfig, ingestReport},
        userDetails,
        contentItem: {data},
        contentItemView: {contentItemViewMetadata},
    } = state;
    return {
        qcToolsMetadata,
        ingestData,
        userDetails,
        initialValuesForEditingIngestConfig,
        ingestReport,
        contentItemData: data,
        contentItemViewMetadata,
    };
};

export default connect(mapStateToProps)(Breadcrumbs);
